import React, { useContext, useState } from 'react'
import { Link, NavLink } from 'react-router'
import { LoginContext } from '../App'
import Calendar from 'react-calendar';
import { toast } from 'react-toastify';

function Header() {

    const {login,setLogin} = useContext(LoginContext);

    const [date, setDate] = useState(new Date());
    const [showCalendar, setShowCalendar] = useState(false);
    
    const logout = () => {
        setLogin(false);

    toast.info("You have been logged out successfully.", {
    position: "top-left",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    // pauseOnHover: true,
    // draggable: true,
    theme: "colored",
    });
};
    return (
        <div>
            {/* ***** Preloader Start ***** */}
                {/* <div id="js-preloader" className="js-preloader">
                    <div className="preloader-inner">
                    <span className="dot" />
                    <div className="dots">
                        <span />
                        <span />
                        <span />
                    </div>
                    </div>
                </div> */}
            {/* ***** Preloader End ***** */}
            <div className="sub-header">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-8">
                            <ul className="info">
                                <li><i className="fa fa-envelope" /> villa123@company.gmail.com</li>
                                <li><i className="fa fa-map" /> Sunny Isles Beach, FL 33160</li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <ul className="social-links">
                                <li><a href="#"><i className="fab fa-facebook" /></a></li>
                                <li><a href="https://x.com/minthu" target="_blank"><i className="fab fa-twitter" /></a></li>
                                <li><a href="#"><i className="fab fa-linkedin" /></a></li>
                                <li><a href="#"><i className="fab fa-instagram" /></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {/* ***** Header Area Start ***** */}
            <header className="header-area header-sticky">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <nav className="main-nav">
                                {/* ***** Logo Start ***** */}
                                <Link to={"/"} className="logo">
                                    <h1>Villa</h1>
                                </Link>
                                {/* ***** Logo End ***** */}
                                {/* ***** Menu Start ***** */}
                                <ul className="nav">
                                    <li><NavLink to={"/"} className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink></li>
                                    <li><NavLink to={"properties"} className={({ isActive }) => isActive ? 'active' : ''}>Properties</NavLink></li>
                                    <li><NavLink to={"propertydetails"} className={({ isActive }) => isActive ? 'active' : ''}>Property Details</NavLink></li>
                                    <li><NavLink to={"contactus"} className={({ isActive }) => isActive ? 'active' : ''}>Contact Us</NavLink></li>
                                    <li><NavLink to={"register"} className={({ isActive }) => isActive ? 'active' : ''}>Register</NavLink></li>
                                    {(login) ? <li><Link onClick={logout}>Logout</Link></li> : <li><NavLink to={"login"} className={({ isActive }) => isActive ? 'active' : ''}>Login</NavLink></li> }
                                    <li style={{ position: 'relative' }}>
                                        <Link onClick={() => setShowCalendar(!showCalendar)}>
                                            <i className="fa fa-calendar"></i> Schedule a visit
                                        </Link>
                                        
                                        {showCalendar && (
                                            <div style={{ position: 'absolute', zIndex: 1000, top: '40px', right: 0 }}>
                                                <Calendar 
                                                    onChange={(newDate) => {
                                                        setDate(newDate);
                                                        setShowCalendar(false); // Date select thaya pachi hide karva
                                                        alert("Selected Date: " + newDate.toDateString());
                                                    }} 
                                                    value={date} 
                                                />
                                            </div>
                                        )}
                                    </li>
                                </ul>
                                <a className="menu-trigger">
                                    <span>Menu</span>
                                </a>
                                {/* ***** Menu End ***** */}
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
            {/* ***** Header Area End ***** */}
        </div>
    )
}

export default Header